export enum RETAIL_FEE_REGION {
  COLORADO = 'colorado',
  MINNESOTA = 'minnesota',
}

export interface IRetailFeeTranslations {
  label: string;
  message: string;
}

type RetailFeeMap = {
  [key in RETAIL_FEE_REGION]?: IRetailFeeTranslations;
};

export const RETAIL_FEE_REGION_TRANSLATIONS_MAP: RetailFeeMap = Object.freeze({
  [RETAIL_FEE_REGION.COLORADO]: {
    label: 'retailDeliveryFee',
    message: 'retailDeliveryFeeTooltipMessage',
  },
  [RETAIL_FEE_REGION.MINNESOTA]: {
    label: 'roadImprovementAndFoodDeliveryFee',
    message: 'roadImprovementAndFoodDeliveryFeeSubjectToSalesTax',
  },
});
